module.exports = "/_next/static/images/play-store-button-e4bd11fe4c9a64d2d6529f22d21d96f3.svg";